import { useIsComerciales } from '.';

export const useIsElectrico = (carlineName?: string) => {
	const isComerciales = useIsComerciales();

	if (!carlineName || typeof carlineName !== 'string') {
		return false;
	}

	const carlineTitle = carlineName.toLowerCase().replace('nuevo', '').trim();

	if (isComerciales) {
		return (
			carlineTitle.substring(0, 3) == 'id.' ||
			carlineTitle.substring(0, 2) == 'e-'
		);
	} else {
		return carlineTitle.substring(0, 3) == 'id.';
	}
};
